module.exports = __webpack_public_path__ + "static/media/Huis-3-4.7d9248db.jpg";